import PdfPrint, { PrintType } from './PdfPrint';

export { PrintType };

export default PdfPrint;
